import React, {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Link, useParams, useNavigate} from "react-router-dom";
import {Badge, Button, FormControl} from "react-bootstrap";
import * as t from "counterpart";
import {addToCart} from "../../Cart/actions";
import {addToFavorites, addToCompare} from "../actions";
import ProductBadges from "./ProductBadges";
import "./style/ProductBox.scss";

const initWithCompare = process.env.REACT_APP_WITH_COMPARE === "true";
let imagePrefix = (process.env.REACT_APP_ENABLE_CLOUDFLARE_IMAGE_RESIZE === "true") ? "/cdn-cgi/image/width=200,quality=90/": "";

function ProductBox({product, withLink=true, withRating=true, withAddToCart=true, withCompare=initWithCompare, withDescription, withQuantity, className="product-box-block"})
{
	const dispatch = useDispatch();
	const {user, favorites, compare} = useSelector(state => ({
		user: state.portal.user,
		favorites: state.commerce.favoritesIDs,
		compare: state.commerce.compare,
	}));

	const [addToCartStatus, setAddToCartStatus] = useState("");
	const [addToFavoritesStatus, setAddToFavoritesStatus] = useState("");
	const [quantity, setQuantity] = useState(1);
	const {store} = useParams();
	const navigate = useNavigate();
	const isFavorite = favorites && favorites.includes(product.id);
	const url = `/${store}/details/${product.slug}-${product.id}`;

	// add to cart
	const onAddToCart = () =>
	{
		setAddToCartStatus("loading");
		let item = {product_id: product.id, quantity: parseInt(quantity)};
		if(!user) {
			item.productData = product;
		}

		dispatch(addToCart(
			[item],
			(status, error) => {
				setAddToCartStatus(status);

				if(error) {
					alert(error);
				}
			},
			!user
		));
	};

	// addToCartLabel
	let addToCartLabel = "Add to Cart";
	if(addToCartStatus === "loading")
		addToCartLabel = "Loading";

	// add to favorites
	const onAddToFavorites = () => {
		setAddToFavoritesStatus("loading");
		dispatch(addToFavorites(product.id, setAddToFavoritesStatus, isFavorite));
	};

	// addToCartLabel
	let addToFavoritesLabel = "Favorite";
	if(addToFavoritesStatus === "loading")
		addToFavoritesLabel = "Loading";

	// compare
	const compareIdx = compare.data.indexOf(product.id);
	const inCompare = compareIdx !== -1;
	const toggleCompare = () =>
	{
		let newList = [...compare.data];
		if(inCompare) {
			newList.splice(compareIdx, 1);
		} else {
			newList.push(product.id);
		}

		dispatch(addToCompare(newList.slice(-4)))
	};

	const ratingAverage = (product.stars / product.reviewers || 5).toFixed(1);
	const InfoTag = withLink ? Link : "div";

	let favoriteClass = "add-to-favorites "+addToFavoritesStatus;
	if(addToFavoritesStatus === "" && isFavorite) {
		favoriteClass += " success";
	}

	return (
		<div className={className}>
			<InfoTag className="box-info" to={url}>
				<div className="image" style={{backgroundImage: "url('"+imagePrefix+product.thumbnail+"')"}}/>
				<div className="product-details">
					<div>
						<h4 className="title">{product.name}</h4>
						{withDescription && <p className="description">{product.description.replace(/(<([^>]+)>)/ig, " ").substr(0, 500).replaceAll("&nbsp;", "")+"..."}</p>}
					</div>

					{withRating &&
					<div className="rating">
						{[1, 2, 3, 4, 5].map(r => <span key={r}>{ratingAverage >= r ? <i className="fa fa-star" /> : (ratingAverage > r-1 ? <i className="fa fa-star-half-stroke" /> : <i className="far fa-star" />)}</span>)} ({ratingAverage})
					</div>}

					{product.type === "parent" && <span className="starting_from">Starting From</span>}
					{!product.current_price && <div className="price">{t("Free")}</div>}
					{!!product.current_price &&
					<div className="price">
						{product.current_price.toLocaleString()} {window.portalSetting("commerce.currency")}
						<div className="old-price">{product.saved_amount ? product.price.toLocaleString() +" "+ window.portalSetting("commerce.currency") : ""} </div>
					</div>}

					<ProductBadges product={product} />
				</div>
			</InfoTag>

			{product.type !== "parent" && withAddToCart &&
			<div className="add-to-cart">
				{product.available_stock ?
				<>
					{withQuantity && <FormControl type="number" min="1" value={quantity} onChange={(e) => setQuantity(parseInt(e.target.value))} />}

					<Button className={addToCartStatus} onClick={onAddToCart} disabled={addToCartStatus === "loading"}>
						<i className="fa fa-basket-shopping" />
						<span>{t(addToCartLabel)}</span>
					</Button>
				</> : <Button variant="danger" disabled>{t("Out of stock")}</Button>}
			</div>}

			<div className="extra-actions">

				{withCompare &&
				<Button className={"add-to-compare "+(inCompare ? "success" : "")} onClick={toggleCompare}>
					<i className="fa fa-check-double" />
					<span>{t("Compare")}</span>
				</Button>}

				<Button className={favoriteClass} onClick={onAddToFavorites}>
					<i className="fa fa-heart" />
					<span>{t(addToFavoritesLabel)}</span>
				</Button>
			</div>

			{inCompare && <Link to={`/${store}/compare`}>{t("Go to compare")}</Link>}
		</div>
	);
};

export default ProductBox;
